<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import IconBook from '~icons/lucide/book-open';

import DocsLink from './DocsLink.vue';
import KaTooltip from './tooltip/KaTooltip.vue';

const route = useRoute();

const computedPath = computed(() => {
  return route.meta?.docs?.path || '';
});

const computedDescription = computed(() => {
  return route.meta?.docs?.description || '';
});

const docsTitle = computed(() => {
  return computedDescription.value
    ? `See Documentation for ${computedDescription.value}`
    : 'See Documentation';
});
</script>

<template>
  <KaTooltip
    :content="docsTitle"
    :root-props="{ delayDuration: 700 }"
    :trigger-props="{ asChild: true }"
  >
    <template #trigger>
      <DocsLink
        class="flex h-10 items-center rounded px-2 text-gray-700 transition-colors hover:text-gray-900 hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-blue-400 dark:text-gray-400 dark:hover:text-gray-50"
        :show-new-tab-icon="false"
        :path="computedPath"
        :aria-label="docsTitle"
      >
        <IconBook class="mr-2 size-4" aria-hidden="true" />
        <span class="hidden font-normal sm:inline">Docs</span>
      </DocsLink>
    </template>
  </KaTooltip>
</template>
